import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';
import { ResponsiveAssignment } from '@core/assignments/types';
import AssignmentCard from '../AssignmentCard/AssignmentCard';
import { createStyles } from './AssignmentList.styles';
import { useSelector } from 'react-redux';
import { getLtiProviders } from '@core/selectors/lti';
import { AulaState } from '@core/types/state';

type Props = {
  assignments: ResponsiveAssignment[];
  spaceId: string;
  isEducator?: boolean;
  onMaterialClick?: (materialId: string) => void;
};

const AssignmentList = ({
  assignments,
  spaceId,
  isEducator,
  onMaterialClick,
}: Props) => {
  const styles = createStyles();
  const state = useSelector((state) => state);
  const providers = getLtiProviders(state as AulaState);

  return (
    <Box sx={styles.listWrapper}>
      {assignments?.map((assignment) => (
        <AssignmentCard
          assignment={assignment}
          key={assignment.id || assignment.objectId}
          spaceId={spaceId}
          providers={providers}
          isEducator={isEducator}
          onMaterialClick={onMaterialClick}
        />
      ))}
    </Box>
  );
};

export default AssignmentList;
